exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-table[data-v-43f4e0f7]{display:flex;flex-direction:column;align-items:stretch;margin:2rem 0}", ""]);

// exports
